module.exports = __webpack_public_path__ + "img/logo-chaleur-90-fr.d09ba9ef.svg";